import filadel from '../image/slide1.png';
import banzai from '../image/slide2.png';
import arigato from '../image/slide3.png';


export const additives = [
   {
      id: 0,
      image: filadel,
      name: 'Філадельфія',
      cost: '140 COM',
   },
   {
      id: 1,
      image: banzai,
      name: 'Банзай',
      cost: '120 COM',
   },
   {
      id: 2,
      image: arigato,
      name: 'Арігато',
      cost: '115 COM',
   },
   {
      id: 3,
      image: banzai,
      name: 'Наруто',
      cost: '130 COM',
   },
   {
      id: 4,
      image: arigato,
      name: 'Узумакі',
      cost: '180 COM',
   },
]